"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryCopilotMetadataForBlocked = exports.arbitraryCopilotMetadata = void 0;
exports.arbitraryTopLevelCommentThreadAnchorData = arbitraryTopLevelCommentThreadAnchorData;
exports.arbitraryCommentThreadAnchorData = arbitraryCommentThreadAnchorData;
exports.arbitraryCommentThread = arbitraryCommentThread;
exports.arbitraryTopLevelCommentThread = arbitraryTopLevelCommentThread;
exports.arbitraryComment = arbitraryComment;
exports.arbitrarySingleThreadAndComments = arbitrarySingleThreadAndComments;
exports.arbitraryThreadsAndComments = arbitraryThreadsAndComments;
exports.arbitraryMessage = arbitraryMessage;
exports.arbitraryCopilotMessage = arbitraryCopilotMessage;
exports.arbitraryCopilotErrorMessage = arbitraryCopilotErrorMessage;
exports.arbitraryCopilotBlockedMessage = arbitraryCopilotBlockedMessage;
const fast_check_1 = require("fast-check");
const structure_1 = require("../../src/comment/structure");
const credit_1 = require("../../src/credit");
const editor_1 = require("../../src/editor");
const credit_2 = require("./credit");
const identifier_1 = require("./identifier");
const vector_1 = require("./vector");
function arbitraryPositionAnchor() {
    return vector_1.arbitraryVector2.map((position) => {
        return {
            type: structure_1.CommentThreadAnchorType.position,
            position,
        };
    });
}
function arbitraryPosition2DAnchor() {
    return vector_1.arbitraryVector2.map((position) => {
        return {
            type: structure_1.CommentThreadAnchorType.pcb2d_position,
            position,
        };
    });
}
function arbitraryReplyAnchor() {
    return (0, fast_check_1.record)({
        type: (0, fast_check_1.constant)(structure_1.CommentThreadAnchorType.reply),
        parent_thread_uid: (0, fast_check_1.string)(),
        reply_to_comment_uid: (0, fast_check_1.string)(),
    });
}
function arbitraryDocumentAnchor() {
    return (0, fast_check_1.record)({
        type: (0, fast_check_1.constant)(structure_1.CommentThreadAnchorType.document),
        document_uid: (0, fast_check_1.string)(),
        context: (0, fast_check_1.constant)(structure_1.DocumentCommentContext.projectChat),
    });
}
function arbitraryTopLevelCommentThreadAnchorData() {
    return (0, fast_check_1.oneof)(arbitraryDocumentAnchor(), arbitraryPosition2DAnchor(), arbitraryPositionAnchor());
}
function arbitraryCommentThreadAnchorData() {
    return (0, fast_check_1.oneof)(arbitraryDocumentAnchor(), arbitraryPosition2DAnchor(), arbitraryPositionAnchor(), arbitraryReplyAnchor());
}
function arbitraryCommentThread(constraints = {}) {
    return (0, fast_check_1.record)({
        anchor: arbitraryCommentThreadAnchorData(),
        reference: (0, fast_check_1.integer)(),
        resolved: (0, fast_check_1.boolean)(),
        owner_uid: constraints.owner_uid ? (0, fast_check_1.constant)(constraints.owner_uid) : (0, fast_check_1.uuid)(),
        created_at: (0, fast_check_1.integer)(),
        updated_at: (0, fast_check_1.integer)(),
        uid: (0, fast_check_1.uuid)(),
    });
}
function arbitraryTopLevelCommentThread(constraints = {}) {
    return (0, fast_check_1.record)({
        anchor: arbitraryTopLevelCommentThreadAnchorData(),
        reference: (0, fast_check_1.integer)(),
        resolved: (0, fast_check_1.boolean)(),
        owner_uid: constraints.owner_uid ? (0, fast_check_1.constant)(constraints.owner_uid) : (0, fast_check_1.uuid)(),
        created_at: (0, fast_check_1.integer)(),
        updated_at: (0, fast_check_1.integer)(),
        uid: (0, fast_check_1.uuid)(),
    });
}
function arbitraryComment(constraints = {}) {
    return (0, fast_check_1.record)({
        owner_uid: constraints.owner ? (0, fast_check_1.constant)(constraints.owner.uid) : (0, fast_check_1.uuid)(),
        created_at: (0, fast_check_1.integer)(),
        updated_at: (0, fast_check_1.integer)(),
        uid: constraints.uid ? (0, fast_check_1.constant)(constraints.uid) : (0, fast_check_1.uuid)(),
        content: constraints.content ? (0, fast_check_1.constant)(constraints.content) : (0, fast_check_1.lorem)(),
        belongs_to_comment_thread_uid: constraints.threadUid ? (0, fast_check_1.constant)(constraints.threadUid) : (0, fast_check_1.uuid)(),
        owner_handle: constraints.owner ? (0, fast_check_1.constant)(constraints.owner.handle) : (0, fast_check_1.string)(),
        editor_mode: (0, fast_check_1.constant)(editor_1.EditorModes.schematic),
    });
}
function arbitrarySingleThreadAndComments(constraints = {}) {
    return arbitraryTopLevelCommentThread(constraints.thread ?? {}).chain((thread) => {
        return (0, fast_check_1.record)({
            thread: (0, fast_check_1.constant)(thread),
            comments: (0, fast_check_1.array)(arbitraryComment({ threadUid: thread.uid, ...constraints.comments }), { minLength: 1 }),
        });
    });
}
function arbitraryThreadsAndComments() {
    return (0, fast_check_1.record)({
        comments: (0, fast_check_1.array)(arbitraryComment()),
        threads: (0, fast_check_1.array)(arbitraryCommentThread()),
    });
}
function arbitraryMessage(constraints = {}) {
    return (0, fast_check_1.record)({
        owner_uid: (0, fast_check_1.uuid)(),
        created_at: (0, fast_check_1.integer)(),
        updated_at: (0, fast_check_1.integer)(),
        uid: constraints.threadUid ? (0, fast_check_1.constant)(constraints.threadUid) : (0, fast_check_1.uuid)(),
        content: (0, fast_check_1.lorem)(),
        belongs_to_comment_thread_uid: (0, fast_check_1.uuid)(),
        owner_handle: (0, fast_check_1.string)(),
        type: (0, fast_check_1.constantFrom)(structure_1.MessageType),
        editor_mode: (0, fast_check_1.constant)(editor_1.EditorModes.schematic),
    });
}
exports.arbitraryCopilotMetadata = (0, fast_check_1.record)({
    respondedTo: (0, fast_check_1.uuid)(),
    totalCreditsUsed: credit_2.arbitraryCreditAmount,
    creditAccountUid: (0, fast_check_1.uuid)(),
    creditAccountHadLowBalance: (0, fast_check_1.boolean)(),
    creditPeriod: credit_2.arbitraryCreditPeriod,
    traceId: (0, fast_check_1.uuid)(),
});
function arbitraryCopilotMessage(constraints = {}) {
    return (0, fast_check_1.record)({
        owner_uid: (0, fast_check_1.uuid)(),
        created_at: (0, fast_check_1.integer)(),
        updated_at: (0, fast_check_1.integer)(),
        uid: constraints.threadUid ? (0, fast_check_1.constant)(constraints.threadUid) : (0, fast_check_1.uuid)(),
        content: (0, fast_check_1.lorem)(),
        belongs_to_comment_thread_uid: (0, fast_check_1.uuid)(),
        owner_handle: (0, fast_check_1.string)(),
        type: (0, fast_check_1.constant)(structure_1.MessageType.finalCopilotStatus),
        editor_mode: (0, fast_check_1.constant)(editor_1.EditorModes.schematic),
        copilotMetadata: exports.arbitraryCopilotMetadata,
    });
}
function arbitraryCopilotErrorMessage(constraints = {}) {
    return (0, fast_check_1.record)({
        // @todo this is copilotUid, but it's currently only in backend - move to constants package to allow access here
        owner_uid: (0, fast_check_1.constant)("ZlptFyOgRpgjoGMu10HDsDK5rgO2"),
        created_at: (0, fast_check_1.integer)(),
        updated_at: (0, fast_check_1.integer)(),
        uid: constraints.threadUid ? (0, fast_check_1.constant)(constraints.threadUid) : (0, fast_check_1.uuid)(),
        content: (0, fast_check_1.lorem)(),
        belongs_to_comment_thread_uid: (0, fast_check_1.uuid)(),
        owner_handle: (0, fast_check_1.string)(),
        editor_mode: (0, fast_check_1.constant)(editor_1.EditorModes.schematic),
        type: (0, fast_check_1.constant)(structure_1.MessageType.copilotError),
        copilotMetadata: exports.arbitraryCopilotMetadata,
    });
}
exports.arbitraryCopilotMetadataForBlocked = (0, fast_check_1.record)({
    respondedTo: (0, fast_check_1.uuid)(),
    totalCreditsUsed: (0, fast_check_1.constant)(credit_1.CreditAmount.parse(0)),
    blockedReason: (0, fast_check_1.oneof)((0, fast_check_1.constantFrom)(...structure_1.CopilotBlockedReason)),
    creditPeriod: credit_2.arbitraryCreditPeriod,
    creditAccountUid: (0, fast_check_1.oneof)(identifier_1.arbitraryUserUid, identifier_1.arbitraryOrganizationUid),
    creditAccountHadLowBalance: (0, fast_check_1.boolean)(),
    traceId: (0, fast_check_1.uuid)(),
});
function arbitraryCopilotBlockedMessage(constraints = {}) {
    return (0, fast_check_1.record)({
        // @todo this is copilotUid, but it's currently only in backend - move to constants package to allow access here
        owner_uid: (0, fast_check_1.constant)("ZlptFyOgRpgjoGMu10HDsDK5rgO2"),
        created_at: (0, fast_check_1.integer)(),
        updated_at: (0, fast_check_1.integer)(),
        uid: constraints.threadUid ? (0, fast_check_1.constant)(constraints.threadUid) : (0, fast_check_1.uuid)(),
        content: (0, fast_check_1.lorem)(),
        belongs_to_comment_thread_uid: (0, fast_check_1.uuid)(),
        owner_handle: (0, fast_check_1.string)(),
        editor_mode: (0, fast_check_1.constant)(editor_1.EditorModes.schematic),
        type: (0, fast_check_1.constant)(structure_1.MessageType.copilotBlocked),
        copilotMetadata: exports.arbitraryCopilotMetadataForBlocked,
    });
}
//# sourceMappingURL=comment.js.map